import React from 'react';

import { useSelector } from 'react-redux';

import { selectNewNativeAppBanner2IterationEnabled } from '../../features/flags/selectors';
import { NewNativeAppBanner } from '../native-app-banner-new';
import { OldNativeAppBanner } from '../native-app-banner-old';

export function NativeAppBanner() {
    const isNewNativeAppBanner2IterationEnabled = useSelector(selectNewNativeAppBanner2IterationEnabled);
    if (isNewNativeAppBanner2IterationEnabled) {
        return <NewNativeAppBanner />;
    } else {
        return <OldNativeAppBanner />;
    }
}

export default NativeAppBanner;
